<template>
  <div class="service-selector">
    <v-select
      :value="currentValue"
      :items="items"
      item-text="label"
      return-object
      label="Servicio"
      hide-details
      no-data-text="No hay servicios disponibles."
      @change="onChange"
    >
      <template v-slot:item="{ item, on, attrs }">
        <v-list-item v-bind="attrs" v-on="on">
          <v-list-item-content>
            <v-list-item-title class="d-flex align-center flex-wrap">
              <v-chip
                v-if="item.isPack"
                x-small
                color="grey lighten-1"
                text-color="white"
                class="mr-2"
                style="border-radius: 4px; height: 18px; flex-shrink: 0;"
              >
                <v-icon x-small left>mdi-package-variant</v-icon>Pack
              </v-chip>
              {{ item.label }}
            </v-list-item-title>
            <v-list-item-subtitle v-if="item.isPack" class="caption mt-1">
              {{ item.count }} servicio{{ item.count !== 1 ? 's' : '' }} incluido{{ item.count !== 1 ? 's' : '' }}
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </template>

      <template v-slot:selection="{ item }">
        <v-chip
          v-if="item.isPack"
          x-small
          color="grey lighten-1"
          text-color="white"
          class="mr-1"
          style="border-radius: 4px; height: 18px;"
        >
          <v-icon x-small left>mdi-package-variant</v-icon>Pack
        </v-chip>
        <span class="text-truncate">{{ item.label }}</span>
      </template>
    </v-select>
  </div>
</template>

<script>
export default {
  name: 'ServiceSelector',
  props: {
    services: { type: Array, default: () => [] },
    groupServices: { type: Array, default: () => [] },
    selectedServices: { type: Array, default: () => [] },
  },
  computed: {
    items() {
      const list = []
      this.services.forEach(s => {
        list.push({ _id: s.id, label: s.service.name, icon: s.service.icon || 'file-document-outline', raw: s, isPack: false })
      })
      this.groupServices.forEach(g => {
        list.push({ _id: g[0].id, label: g[0].name, count: g.length, raw: g, isPack: true })
      })
      return list
    },
    currentValue() {
      if (!this.selectedServices.length) return null
      const activeId = this.selectedServices[0].id
      return this.items.find(i => i._id === activeId) || null
    },
  },
  methods: {
    onChange(item) {
      if (!item) return
      this.$emit('change', item.raw)
    },
  },
}
</script>
